import React from 'react';
import { Card } from 'antd';
import { SkHeader, SkTabsBar, SkFilterBar, SkTable } from './_primitives';

/** EarningRulesPage — header, rule type tabs, search+filters, rules table */
const EarningRulesPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    <SkHeader actions={2} />
    <Card className="shadow-sm">
      <SkTabsBar tabs={4} />
      <SkFilterBar filters={3} withButton />
      <div className="overflow-x-auto">
        <SkTable rows={8} cols={6} inCard={false} />
      </div>
    </Card>
  </div>
);

export default EarningRulesPageLoader;
